import { useState } from 'react';
import { T, useTheme, dens, Ico, Card, Input } from '../../../design';
import type { SalonListItem } from '../../../types/portal.types';
import { PersonRow } from './PersonRow';

export interface AdminSalonsProps {
  salons: SalonListItem[];
  onPick: (salon: SalonListItem) => void;
}

export function AdminSalons({ salons, onPick }: AdminSalonsProps) {
  const t = useTheme();
  const d = dens(t);
  const [q, setQ] = useState('');
  const list = salons.filter((s) => s.name.toLowerCase().includes(q.trim().toLowerCase()));
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <Card pad={14} style={{ background: T.dark, border: 'none' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ width: 34, height: 34, borderRadius: 10, background: T.accentLight, color: T.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Ico.bolt size={18} /></span>
          <div><div style={{ fontSize: 14, fontWeight: 800, color: T.onAccent }}>Admin-mode</div><div style={{ fontSize: 11.5, color: T.onDarkMuted, fontWeight: 600 }}>Vælg salonen, du vil agere i</div></div>
        </div>
      </Card>
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Søg salon…" icon={<Ico.search size={18} />} />
      <Card pad={0}>
        {list.length === 0 ? <div style={{ padding: 24, textAlign: 'center', color: T.fg3, fontSize: 13, fontWeight: 600 }}>Ingen saloner fundet</div>
          : list.map((s) => <PersonRow key={s.id} name={s.name} sub={s.city ?? undefined} onClick={() => onPick(s)} right={<Ico.chevR size={18} style={{ color: T.fg3 }} />} />)}
      </Card>
    </div>
  );
}
